import React, { Component } from "react";
import { Link } from "react-router-dom";

class NavMenu extends Component {
  render() {
    return (
      <nav className="main-nav">
        <ul
          id="menu-header"
          className="nav__list"
          toolbar-target="target-element"
        >
          <li className="nav__item">
            <Link
              to="/"
              className="nav__link"
              onClick={this.props.onToggleMenu}
            >
              Home
            </Link>
          </li>
          {/* <li className="nav__item">
            <Link
              to="/tour"
              className="nav__link"
              onClick={this.props.onToggleMenu}
            >
              Legends Tour
            </Link>
          </li> */}
          {/* <li className="nav__item">
            <Link
              to="/clubhouse"
              className="nav__link"
              onClick={this.props.onToggleMenu}
            >
              Staysure Clubhouse
            </Link>
          </li> */}
          {/* <li className="nav__item">
            <Link
              to="/products"
              className="nav__link"
              onClick={this.props.onToggleMenu}
            >
              Products
            </Link>
          </li> */}
          <li className="nav__item ">
            <Link
              to="/claims"
              className="nav__link "
              onClick={this.props.onToggleMenu}
            >
              Claims
            </Link>
          </li>
          <li className="nav__item ">
            <Link
              to="/documents"
              className="nav__link "
              onClick={this.props.onToggleMenu}
            >
              Documents
            </Link>
          </li>
          <li className="nav__item ">
            <Link
              to="/contact"
              className="nav__link "
              onClick={this.props.onToggleMenu}
            >
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}

export default NavMenu;
